import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Export = (props) => (
  <Icon viewBox="0 0 15 14" {...props}>
    <g>
      <title>export</title>
      <path d="M7 1.5V11h1V1.5L10.5 4l.5-.625L7.5 0 4 3.375 4.5 4 7 1.5zM14 8v3.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5V8H0v3.5C0 12.878 1.122 14 2.5 14h10c1.378 0 2.5-1.122 2.5-2.5V8h-1z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Export;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Export.js